<template>
  <fragment>
    <default-header :h2="$t('newClient.title')"></default-header>

    <div class="innerContent justifyContentFlexStart">
      <h4 class="form-title mb-3">{{$t('newClient.addContactDetails')}}</h4>
      <div class="additionalPadding">
        <input-standard
          :label="$t('general.name')"
          :name="'name'"
          v-validate="'required'"
          :data-vv-as="$t('general.name')"
          @changedValue="contactDetailsInputChanged"
          :error="errors.first('name') ? $t('general.nameFieldIsRequired')  : false"
        />

        <input-standard
          :label="$t('general.lastName')"
          :name="'lastName'"
          @changedValue="contactDetailsInputChanged"
          v-validate="'required'"
          :data-vv-as="$t('general.lastName')"
          :error="errors.first('lastName') ? $t('general.lastNameFieldIsRequired')  : false"
        />

        <div
          class="form-group small-label inputStandard"
          :style="{'margin-bottom': telephonOrEmailError ? '.2rem' : '1.1rem'}"
        >
          <label v-if="contactDetails.telephone" :for="'telephone'">{{ $t('general.telephone') }}</label>
          <input
            :type="'text'"
            :class="{
              'form-control': true,
              'has-error': isValid('contact_details.telephone')
            }"
            :name="'telephone'"
            :id="'telephone'"
            @keypress="allowOnlyDigits"
            v-model="contactDetails.telephone"
            :aria-describedby="'telephone'"
            :placeholder="$t('general.telephone')"
          />
          <span
            v-if="telephonOrEmailError"
            class="vv-error"
          >{{ $t('general.emailAndPhoneFieldIsRequired') }}</span>
        </div>

        <input-standard
          :label="$t('general.email')"
          :name="'email'"
          :data-vv-as="$t('general.email')"
          @changedValue="contactDetailsInputChanged"
          :error="telephonOrEmailError ? $t('general.emailAndPhoneFieldIsRequired')  : false"
        />
      </div>
      <h4 class="form-title mb-3">{{$t('newClient.vehicleTypeTitle')}}</h4>
      <div class="additionalPadding">
        <select-standard
          :list="vehicleTypes"
          :name="'vehicleType'"
          :chosen="contactDetails.vehicleType"
          :label="$t('newClient.vehicleType')"
          @selected="selectChangedValue"
          :error="vehicleTypeError ? $t('newClient.vehicleTypeFieldIsRequired') : false"
        />
      </div>
      <div v-if="[1,2].includes(contactDetails.vehicleType.id)">
        <h2 class="text-center h2 mb-3">{{$t('newClient.drivingPatternStyle')}}</h2>
        <h4 class="form-title mb-3">{{$t('newClient.howManyTripsPerDay')}}</h4>
        <div class="additionalPadding">
          <input-standard
            :label="$i18n.locale === 'Dutch' ? 'Aantal' : $t('general.number')"
            :name="'trips'"
            :data-vv-as="$t('general.number')"
            @changedValue="drivingDetailsInputChanged"
            :type="'number'"
          />
        </div>
        <h4 class="form-title mb-3">{{$t('newClient.howManyKmPerDay')}}</h4>

        <div class="additionalPadding">
          <input-standard
            :label="$t('newClient.distance')"
            :name="'distance'"
            :data-vv-as="$t('newClient.distance')"
            @changedValue="drivingDetailsInputChanged"
            :type="'number'"
          />
        </div>
        <h4 class="form-title mb-3">{{$t('report.capacity')}}</h4>
        <div class="additionalPadding">
          <input-standard
            :label="$t('otherBattery.capacityAh')"
            :name="'capacity'"
            :data-vv-as="$t('report.capacity')"
            @changedValue="capacitySendLocalStorage"
            :type="'number'"
          />
        </div>
      </div>
      <div class="additionalPadding">
        <button
          class="btn btn-primary fw mt-3 mb-3"
          @click.prevent="createClient(false)"
        >{{$t('general.continue')}}</button>
      </div>
    </div>
    <bottom-navigation></bottom-navigation>
  </fragment>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import DefaultHeader from '@/partials/DefaultHeader';
import BottomNavigation from '@/partials/BottomNavigation';
import WizardSteps from '@/partials/WizardSteps';
import InputStandard from '../components/InputStandard';
import SelectStandard from '../components/SelectStandard';
import BackBtn from '../components/BackBtn';
import { HTTP } from '../http';

export default {
  name: 'NewClient',
  components: {
    DefaultHeader,
    BottomNavigation,
    WizardSteps,
    InputStandard,
    BackBtn,
    SelectStandard
  },
  data() {
    return {
      contactDetails: {
        vehicleType: '',
        telephone: '',
        email: ''
      },
      vehicleTypes: [
        { id: 1, name: this.$t('newClient.vehicleTypeCar') },
        { id: 2, name: this.$t('newClient.vehicleTypeBus') },
        { id: 3, name: this.$t('newClient.vehicleTypeMarine') }
      ],
      drivingPattern: {
        trips: null,
        distance: null,
        capacity: null
      },
      telephonOrEmailError: false,
      vehicleTypeError: false,
      countries: []
    };
  },
  beforeMount() {
    HTTP.get('api/app/config').then(res => {
      this.countries = res.data.countries;
      const prefix = this.countries.filter(country => country.country == this.user.country);
      prefix ? (this.contactDetails.telephone = prefix[0].prefix) : false;

      this.vehicleTypes = [
        { id: 1, name: this.$t('newClient.vehicleTypeCar') },
        { id: 2, name: this.$t('newClient.vehicleTypeBus') },
        { id: 3, name: this.$t('newClient.vehicleTypeMarine') }
      ]

      this.contactDetails.vehicleType = { id: 1, name: this.$t('newClient.vehicleTypeCar') }
    });
  },
  mounted() {
    this.clearCurrentProccess();

    this.drivingPattern.trips = null;
    this.drivingPattern.distance = null;

    $('.paddingToHide').css('padding-left', '0px');
    $('.paddingToHide').css('padding-right', '0px');
  },
  destroyed() {
    $('.paddingToHide').css('padding-right', '15px');
    $('.paddingToHide').css('padding-left', '15px');
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      responseError: 'getNewClientCreateErrors',
    })
  },

  methods: {
    ...mapActions(['createClientAction', 'clearCurrentProccess']),
    contactDetailsInputChanged(name, value) {
      this.contactDetails[name] = value;
    },
    isValid(key) {
      if (this.responseError && key in this.responseError) {
        return true;
      }
    },
    drivingDetailsInputChanged(name, value) {
      this.drivingPattern[name] = value;
    },
    selectChangedValue(name, value) {
      if (name === 'vehicleType' && value.id === 3) {
        this.drivingPattern.trips = null;
        this.drivingPattern.distance = null;
      }
      this.contactDetails[name] = value;
      this.$forceUpdate();
    },
    capacitySendLocalStorage(name, value) {
      this.drivingPattern.capacity = value;
      localStorage.setItem(name, value);
    },

    createClient: function(skipDrivingPattern) {
      this.telephonOrEmailError = false;
      const validateInputs = this.validateInputs();
      this.$validator.validate().then(valid => {
        if (valid && validateInputs) {
          this.$store.commit('SET_NEW_CLIENT_CONTACT_DETAILS', this.contactDetails);
          localStorage.setItem('exideVehicleType', this.contactDetails.vehicleType.id);

          this.$store.commit(
            'SET_NEW_CLIENT_DRIVING_PATTERN',
            skipDrivingPattern ? null : this.drivingPattern
          );
          this.createClientAction();
        }
      });
    },
    validateInputs() {
      if (
        this.contactDetails.telephone.length <= 3 &&
        !this.validateEmail(this.contactDetails.email)
      ) {
        this.telephonOrEmailError = true;
        return false;
      } else {
        return true;
      }
    },
    validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },

    allowOnlyDigits(event) {
      let keyCode = event.keyCode ? event.keyCode : event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 43) {
        event.preventDefault();
      }
    }
  }
};
</script>


